import React from 'react';
import { TrackingPropsInterface } from '@marriott/mi-ui-library';

export enum ATextInteractiveSize {
  XS = 'XS',
  S = 'S',
  M = 'M',
}

export interface ATextInteractiveProps extends React.HTMLAttributes<HTMLSpanElement | HTMLAnchorElement> {
  text: string;
  size?: ATextInteractiveSize;
  href?: string;
  trackingProperties?: TrackingPropsInterface;
  isExternal?: boolean;
  custom_click_track_value?: string;
  preTrackVal?: string;
}
